export default "__VITE_ASSET__CyIJv$NY__"